import { PendingCapitalI } from "../../../../../../api/request/Lead/Interfaces/PolicyInterface";
import numberFormat from "../../../../../../utils/Utils";

/**
 * Bajada de capital firmada con fecha de efecto futura (gf-monorepo #10199): el
 * capital que pinta el portal es el VIGENTE y, debajo, una línea visible con el
 * capital que regirá y desde cuándo: «30.000 € a partir del 01/05/2027».
 *
 * Clave pendiente de crear en `getlife/translations` (ver docs/i18n-pending.md);
 * mientras no llegue, el literal ES.
 */
export const PENDING_CAPITAL_KEY = "newDashboard.pendingCapital.fromDate";
export const PENDING_CAPITAL_FALLBACK = "{capital} a partir del {date}";

export type TranslateFn = (key: string) => string;

/** «2027-05-01» → «01/05/2027», como el resto de fechas del portal. */
export const formatEffectiveDate = (ymd: string): string => {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(ymd ?? "");
  return match ? `${match[3]}/${match[2]}/${match[1]}` : ymd;
};

/**
 * Capital pendiente que toca enseñar junto a un importe vigente, o null.
 * - Sin `trait`: el capital principal (`pendingCapital.capital`).
 * - Con `trait`: el de esa garantía en `capitalsByTrait`; en una póliza de una
 *   sola garantía (`capitalsByTrait` null) solo fallecimiento, con `capital`.
 * Si no cambia respecto al vigente, no se enseña nada.
 */
export const pendingCapitalFor = (
  pendingCapital: PendingCapitalI | null | undefined,
  current: number,
  trait?: string
): number | null => {
  if (!pendingCapital) return null;
  let amount: number | undefined;
  if (undefined === trait) {
    amount = pendingCapital.capital;
  } else if (pendingCapital.capitalsByTrait) {
    amount = pendingCapital.capitalsByTrait[trait];
  } else if ("DEATH" === trait) {
    amount = pendingCapital.capital;
  }
  if ("number" !== typeof amount || !Number.isFinite(amount) || amount === current) {
    return null;
  }
  return amount;
};

export const pendingCapitalText = (
  translate: TranslateFn,
  amount: number,
  effectiveDate: string
): string => {
  const translated = translate(PENDING_CAPITAL_KEY);
  const template =
    translated && PENDING_CAPITAL_KEY !== translated ? translated : PENDING_CAPITAL_FALLBACK;
  return template
    .replace("{capital}", numberFormat(amount, "capital"))
    .replace("{date}", formatEffectiveDate(effectiveDate));
};
